export default __webpack_public_path__ + "static/media/AutonomousPersona.c84a7bab.png";